<div class="container-fluid widget-wrapper" #widgetHeader>
  <div class="row widget-header" [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2>
        <span>Made For Advertising (MFA) Risk</span>
        <span class="app-title">&nbsp;{{ appName | appPrefix }}</span>
        <img class="beta-tag" src="/assets/images/beta-tag.png" alt="Beta Tag" />
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body">
    <div class="col-lg-12 px-0">
      <app-ctv-app-mfa [data]="data">
      </app-ctv-app-mfa>
    </div>
  </div>
</div>